import FeedBody from 'views/DesktopViews/OtherProfilePage/ProfilePageBody/FeedBody';
// import PaywallBody from 'views/DesktopViews/ProfilePage/ProfilePageBody/PaywallBody';
import MobileGalleryBody from './MobileGalleryBody';
import CollectedBody from './CollectedBody';

const Profile = (props: any) => {

  return (
    <>
      {props.page.gallery ? (
        <MobileGalleryBody />
      ) : props.page.collected ? (
        <CollectedBody />
      ) : props.page.backstage ? (
        <FeedBody user={props.data} />
      ) : props.page.feeds ? (
        <FeedBody user={props.data} />
      ) : (
        <></>
      )}
    </>
  );
};

export default Profile;
